import axios from "axios";
import { saveAs } from "file-saver";
import { handleUnauthorizedSession, startSessionStatusPolling } from "../utils/auth";

let sessionInterceptorRegistered = false;

export const apiHost = process.env.REACT_APP_API_HOST
    ? `${process.env.REACT_APP_API_HOST}`
    : process.env.NODE_ENV === "development"
        ? "http://localhost:63362"
        : window.location.origin

export function registerSessionMonitoring() {
    if (!sessionInterceptorRegistered) {
        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (handleUnauthorizedSession(error)) {
                    return new Promise(() => {});
                }

                return Promise.reject(error);
            }
        );
        sessionInterceptorRegistered = true;
    }

    startSessionStatusPolling(apiHost, axios);
}

export function encodeQueryData(data) {
    console.log("api client data", data);
    const ret = [];
    for (let d in data) {
        if (data[d]) {
            ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
        }
    }

    return ret.join("&");
}

export async function downloadCSVFile(data, reportType, assetName, timeZone, assetId) {
    let timeZonesId = localStorage.getItem("timeZoneID");
    if (assetName === '' || assetName === undefined || assetName === null) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        assetName = urlParams.get("assetName");
    }
    try {
        let response = await axios.post(
            `${apiHost}/api/Csv/GetCsv`,
            { data, timeZonesId, reportType, assetName, assetId },
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            }
        );
        var blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
        var fileName = reportType && assetName && timeZone ? `${reportType}_${assetName}_${timeZone}.csv` : 'file.csv';
        saveAs(blob, fileName);
    } catch (e) {
        console.log(`😱 Axios request failed: ${e}`);
    }
}
